import type { Location } from 'bookings-shared/lib/c2/services/schema/serviceLocation';

export const mapLocation = (location?: Location): string => {
    if (location && location.displayName) {
        const { city, countryOrRegion, postOfficeBox, postalCode, state, street } =
            location.address ?? {};
        const displayName = location.displayName;
        const mappedLocation = `${displayName} (${street}${postOfficeBox}, ${city} ${state} ${postalCode} ${countryOrRegion}) `;
        return mappedLocation;
    } else {
        return '';
    }
};

export default mapLocation;
